module.exports = __webpack_public_path__ + "static/media/timg.31c7d184.jpeg";